var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55526 10.0234L9.02752 7.05361H6.07473V5.12645C6.07473 4.31398 6.48721 3.52202 7.80967 3.52202H9.15207V0.993602C9.15207 0.993602 7.93388 0.792969 6.76917 0.792969C4.33745 0.792969 2.74797 2.21535 2.74797 4.79024V7.05361H0.0449219V10.0234H2.74797V17.2026H6.07473V10.0234H8.55526Z",
    fill: "#003A9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.35ebd09645a3e4fd2b404b4c560aeff3.svg";
export { ForwardRef as ReactComponent };